import SimpleBoxDisplay from "../../../common/SimpleBoxDisplay";

export default function CollectionRep({label, value, contact_info, type, maxWidth}) {
    return <SimpleBoxDisplay label={label} value={value} contact_info={contact_info} type={type} maxWidth={maxWidth}/>                               
}